import React from 'react';
import BottomNav from '@/components/BottomNav';
import CreatePostFAB from '@/components/CreatePostFAB';
import NotificationBell from '@/components/NotificationBell';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Shield, Building2 } from 'lucide-react';

export default function AppShell({
  children,
  title,
  showNav = true,
  headerLeft,
  headerRight,
  hideBell = false,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  const isOrgAdmin = user?.role === 'org_admin';

  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-[#F6F8FB] relative overflow-x-hidden md:max-w-xl lg:max-w-2xl">
      {/* Ambient side gradients (visible on wider screens as premium edge glow) */}
      <div aria-hidden className="pointer-events-none absolute inset-y-0 -left-8 w-16 bg-gradient-to-r from-[#0B4F3F]/[0.03] to-transparent hidden md:block" />
      <div aria-hidden className="pointer-events-none absolute inset-y-0 -right-8 w-16 bg-gradient-to-l from-[#0B4F3F]/[0.03] to-transparent hidden md:block" />

      {title && (
        <header className="sticky top-0 z-40 bg-[#F6F8FB]/75 backdrop-blur-2xl border-b border-[#E4E8EF] px-5 py-3.5 flex items-center gap-3">
          {headerLeft && <div className="flex-shrink-0">{headerLeft}</div>}
          <h1 className="text-lg font-semibold text-[#0B1620] font-['Bricolage_Grotesque'] tracking-tight flex-1 min-w-0 truncate">{title}</h1>
          <div className="flex items-center gap-2 flex-shrink-0">
            {isAdmin && (
              <button
                data-testid="switch-to-admin-btn"
                onClick={() => navigate('/admin')}
                aria-label="Switch to admin view"
                className="text-[11px] font-semibold text-[#0B4F3F] bg-[#0B4F3F]/10 hover:bg-[#0B4F3F]/20 border border-[#0B4F3F]/20 rounded-full px-2.5 py-1 flex items-center gap-1 transition-colors"
              >
                <Shield className="w-3.5 h-3.5" /> Admin
              </button>
            )}
            {isOrgAdmin && (
              <button
                data-testid="switch-to-org-btn"
                onClick={() => navigate('/org')}
                aria-label="Switch to org view"
                className="text-[11px] font-semibold text-[#0B4F3F] bg-[#0B4F3F]/10 hover:bg-[#0B4F3F]/20 border border-[#0B4F3F]/20 rounded-full px-2.5 py-1 flex items-center gap-1 transition-colors"
              >
                <Building2 className="w-3.5 h-3.5" /> Org
              </button>
            )}
            {headerRight}
            {!hideBell && <NotificationBell />}
          </div>
        </header>
      )}
      <div className={`${showNav ? 'pb-28' : ''}`}>
        {children}
      </div>
      {showNav && <BottomNav />}
      {showNav && <CreatePostFAB />}
    </div>
  );
}
